import {Component, Input} from '@angular/core';
import {AffiliateService} from "../../../core/services/affiliate.service";
import {CommonService} from "../../../core/services/common.service";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent {
  @Input() headersHeading:any;
  userCode:any;
  customer: any;
  constructor(private affiliateService: AffiliateService,private common:CommonService) {
    this.customer = this.common.getStorage('customer');
    this.userCode=this.customer.firstName.charAt(0).toUpperCase()+this.customer.lastName.charAt(0).toUpperCase();
  }
}
